import { Component, OnInit } from '@angular/core';
import { DashboardService} from '../dashboard/dashboard.service';
@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css']
})
export class EmployeeComponent implements OnInit {
  public employeelistarr = [];
  public totalElements: any = 0;
  public rmprojectSearch: string = '';
  public userfilterproject: any = { Project: '' };
  constructor(public projectsService: DashboardService) { }

  ngOnInit() {
    this.getrmEmployeeLists();
  }
  getrmEmployeeLists() {
    this.employeelistarr = [];
    this.projectsService.getDashboardEmployeeList().subscribe(
      (data) => {
        if (data.payload.employeeCount) {
          data.payload.employeeCount.empList.forEach(value => {
            this.employeelistarr.push(value);
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/employee/employee.component.ts